export default __webpack_public_path__ + "img/f42a7257759e919ede1583d06a0b91ad.png";